import React from 'react';
import { Provider } from 'react-redux';
import store from './Store/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { reactPlugin } from "./MPP-Common-SPA/common/logging/logging";
import {
  useAppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import CanadaPostAddressComplete from "./MPP-Common-SPA/Widgets/AddressComplete/CanadaPostAddressComplete";
import App from "./App";

import "./index.css";

const queryClient = new QueryClient();

const Root = () => {
  const appInsightsContext = useAppInsightsContext();

  // Add types for error and errorInfo
  const handleLogError: any = (error: Error, errorInfo: React.ErrorInfo): void => {
    appInsightsContext.trackException({ exception: error, properties: { errorInfo } });
  };

  return (
  <React.StrictMode>
    <AppInsightsErrorBoundary
      onError={handleLogError}
      appInsights={reactPlugin}
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <CanadaPostAddressComplete />
          <App />
        </QueryClientProvider>
      </Provider>
    </AppInsightsErrorBoundary>
  </React.StrictMode>
  );
}

export default Root;
